if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  document.body.classList.add('mac-os');
} else {
  document.body.classList.add('window-os');
}

document.addEventListener('DOMContentLoaded', function () { 
  function ValidateEmail(email) {
    var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return expr.test(email);
  };

  document.addEventListener('click', function (event) {
    // Match: footer .footer__item-content .needsclick button[type=button]
    if (event.target.matches('footer .footer__item-content .needsclick button[type=button]')) {
      const emailInput = document.querySelector('.footer__item-content input[type=email]');
      if (emailInput && ValidateEmail(emailInput.value)) {
        const newsletter = document.querySelector('.footer__item--newsletter');
        if (newsletter) {
          newsletter.classList.add('newsletter_klaviyo_form_success');
          setTimeout(() => {
            newsletter.classList.add('newsletter_klaviyo_form_success');
          }, 1000);
          setTimeout(() => {
            newsletter.classList.add('newsletter_klaviyo_form_success');
          }, 2000);
        }
      }
    }
  });

  setTimeout(function () {
    const emailInput = document.querySelector('.footer__item-content input[type=email]');
    if (emailInput) {
      emailInput.setAttribute('placeholder', 'Email');
    }
  }, 5000);

  // add lazy load
  // var images = document.querySelectorAll('img');
  // images.forEach(function(image) {
  //     image.loading = 'lazy';
  // });
  // add width and height
/*   var images_width = document.querySelectorAll('img:not([width]):not([height])');
  images_width.forEach(function (image) {
    var img = new Image();
    img.onload = function () {
      image.width = this.width;
      image.height = this.height;
    };
    img.src = image.src;
  }); */
});

/* document.addEventListener('DOMContentLoaded', function () {
  const qtyIncrease = document.querySelector('.quantity-selector__button.qty-increase');
  const qtyDecrease = document.querySelector('.quantity-selector__button.qty-decrease');
  const quantityInput = document.querySelector('.quantity-selector__input');
  const hiddenQty = document.querySelector('.form-hidden-qty-num');

  // Increase quantity
  qtyIncrease.addEventListener('click', function () {
    let currentValue = parseInt(quantityInput.value) || 1;
    hiddenQty.value = currentValue + 1;
  });

  // Decrease quantity
  qtyDecrease.addEventListener('click', function () {
    let currentValue = parseInt(quantityInput.value) || 1;
    if (currentValue > 1) {
      hiddenQty.value = currentValue - 1;
    }
  });
}); */


//New Custom
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  const swatches = document.querySelectorAll(".pcf--swatch");
  swatches.forEach((swatch) => {
    swatch.addEventListener("mouseover", function () {
      const variantImg = this.getAttribute("data-variant-image");
      const variantId = this.getAttribute("data-variant-id");
      const productBlock = this.closest('.ftrp--product-block');

      if (!productBlock) return;

      const productImg = productBlock.querySelector('.ftrp--product-image');
      const variantInputs = productBlock.querySelectorAll('[name="id"]');

      if (productImg && variantImg) {
        productImg.src = variantImg;
        productImg.srcset = `${variantImg} 1x`;
      }

      variantInputs.forEach(input => {
        input.value = variantId;
      });

      productBlock.querySelectorAll('.pcf--swatch').forEach(s => {
        s.classList.remove('color-active');
      });
      this.classList.add('color-active');
    });
  });

  const hoverTarget = document.querySelector('.header__icon-learnmore');
  const toggleElement = document.querySelector('.menu-learn-more');

  if(hoverTarget && toggleElement ) {
    hoverTarget.addEventListener('click', () => {
      toggleElement.hidden = !toggleElement.hidden;
    });
  }

  const mobileMenuToggle = document.querySelector('.header__icon-list .icon-burger-mobile button[is=toggle-button]');
  const mainHeader = document.querySelector('.header');

  if(mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function () {
      if (mobileMenuToggle.getAttribute('aria-expanded') == 'true') {
        mainHeader.classList.add('mobile-menu-opened');
        setTimeout(function () {
          initFlickityCarousel('.header__secondary--carousel');
        }, 300);
      }
      else {
        mainHeader.classList.remove('mobile-menu-opened');
      }
    });
  }

  const stampedBadge = document.querySelector('.pffr--wrapper .stamped-product-reviews-badge');
  if (stampedBadge) {
    stampedBadge.addEventListener('click', (e) => {
      e.stopPropagation();
      stampedBadge.closest('button.collapsible-toggle').click();
    });
  }

  function initFlickityCarousel(selector) {
    this.flickity = new Promise(async (resolve) => {
      await LibraryLoader.load("flickity");
  
      //const carousels = document.querySelectorAll('.cx-flickity-carousel:not(.cx-tab-carousel)');
      const carousels = document.querySelectorAll(selector);
      const instances = {};
  
      // Initialize each Flickity instance
      carousels.forEach((carouselEl) => {
        const id = carouselEl.dataset.carousel; // match with arrow data
        
        // Base options
        const options = {
          //cellAlign: 'left',
          contain: true,
          wrapAround: false,
          //wrapAround: true,
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: false,
          groupCells: true
        };
  
        if (carouselEl.dataset.carouselAutoplay === "true") {
          options.autoPlay = true;
        }
        else if (carouselEl.dataset.carouselAutoplay === "false") {
          options.autoPlay = false;
        }
        else {
          options.autoPlay = carouselEl.dataset.carouselAutoplay;
        }

        if (carouselEl.dataset.carouselArrows === "true") {
          options.prevNextButtons = true;
        }

        if (carouselEl.dataset.carouselDots === "true") {
          options.pageDots = true;
        }

        if (carouselEl.dataset.adaptiveHeight === "true") {
          options.adaptiveHeight = true;
        }
        
        if (carouselEl.dataset.carouselWrapAround === "true") {
          options.wrapAround = true;
        }

        if (carouselEl.dataset.carouselDraggable === "false") {
          options.draggable = false;
        }
        
        const flkty = new window.ThemeFlickity(carouselEl, options);
        instances[id] = flkty;

        // 🔹 Resize handler
        window.addEventListener("resize", () => {
          flkty.resize();
        });

        // 🔹 If inside hidden tabs/accordions, trigger resize when shown
        // Example: when the element becomes visible
        const observer = new MutationObserver(() => {
          if (carouselEl.offsetParent !== null) {
            flkty.resize();
          }
        });
        observer.observe(carouselEl, { attributes: true, attributeFilter: ["style", "class"] });
  
        // Find matching arrows for this carousel
        const prevBtn = document.querySelector(`.flickity-prev[data-carousel-target="${id}"]`);
        const nextBtn = document.querySelector(`.flickity-next[data-carousel-target="${id}"]`);
  
        // Update arrow states
        function updateArrows() {
          if (prevBtn) prevBtn.disabled = flkty.selectedIndex === 0;
          if (nextBtn) nextBtn.disabled = flkty.selectedIndex === flkty.slides.length - 1;
        }
  
        // Initial state
        updateArrows();
  
        // Update on slide change
        flkty.on('change', updateArrows);
  
        // Attach click events
        if (prevBtn) {
          prevBtn.addEventListener('click', () => flkty.previous());
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => flkty.next());
        }
      });
  
      resolve(instances);
    });
  }

  initFlickityCarousel('.cx-flickity-carousel:not(.header__secondary--carousel)');

  document.addEventListener("shopify:section:load", function(event) {
    const carousels = event.target.querySelectorAll(".cx-flickity-carousel");
    if (carousels.length > 0) {
      initFlickityCarousel(".cx-flickity-carousel");
    }
  });

  /* Tabbed Carousel */
  function enableTabCarousels() {
    initFlickityCarousel('.cx-tab-carousel');
    document.querySelectorAll("tabs-nav").forEach((tabsNav) => {
      tabsNav.addEventListener("tabs-nav:changed", function (e) {
        const panelId = e.detail.button.getAttribute("aria-controls");
        const panel = document.getElementById(panelId);
        const carouselEl = panel?.querySelector(".cx-tab-carousel");
    
        if (!carouselEl) return;
    
        const flkty = carouselEl.flickityInstance || window.ThemeFlickity.data(carouselEl);
        if (flkty) {
          setTimeout(() => flkty.resize(), 300);
        }
      });
    });
  }

  function disableTabCarousels() {
    document.querySelectorAll(".cx-tab-carousel").forEach((carouselEl) => {
      const flkty = carouselEl.flickityInstance || window.ThemeFlickity.data(carouselEl);
      if (flkty) {
        flkty.destroy();
        carouselEl.flickityInstance = null;
      }
    });
  }

  function checkCarousels() {
    if (window.innerWidth > 749) {
      enableTabCarousels();
    } else {
      disableTabCarousels();
    }
  }

  window.addEventListener("resize", checkCarousels);
  document.addEventListener("DOMContentLoaded", checkCarousels);

  /* window.addEventListener("resize", () => {
    if(window.innerWidth > 749) {
      initFlickityCarousel('.cx-tab-carousel');
      document.querySelectorAll("tabs-nav").forEach((tabsNav) => {
        tabsNav.addEventListener("tabs-nav:changed", function (e) {
          const panelId = e.detail.button.getAttribute("aria-controls");
          const panel = document.getElementById(panelId);
          const carouselEl = panel?.querySelector(".cx-tab-carousel");
      
          if (!carouselEl) return;
      
          const flkty = window.ThemeFlickity.data(carouselEl);
          if (flkty) {
            setTimeout(() => {
              flkty.resize();
            }, 300);
          }
        });
      });
    }
  }); */
    
  /* Home Tabs */
  document.querySelectorAll('.home_aeropress_tabs').forEach(function (sectionEl) {
    sectionEl.querySelectorAll('.tab-features').forEach(function (tabFeaturesEl) {
      const features = tabFeaturesEl.querySelectorAll('.tab-feature');
      const maxVisible = 5;

      if (features.length > maxVisible) {
        // Hide features beyond maxVisible
        features.forEach(function (feature, index) {
          if (index >= maxVisible) {
            feature.style.display = 'none';
          }
        });

        // Create "Show More" button
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'Show More';
        button.classList.add('read-more-btn');
        tabFeaturesEl.appendChild(button);

        let isExpanded = false;

        button.addEventListener('click', function () {
          if (isExpanded) {
            features.forEach(function (feature, index) {
              if (index >= maxVisible) {
                feature.style.display = 'none';
              }
            });
            button.textContent = 'Show More';
          } 
          else {
            features.forEach(function (feature) {
              feature.style.display = '';
            });
            button.textContent = 'Show Less';
          }
          isExpanded = !isExpanded;
        });
      }
    });
  });
});
